module.exports = __webpack_public_path__ + "img/WELCOME_NEW_MEMBER.09e2a8ef.png";